'use client';

import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { FC, ReactNode } from 'react';
import { cn } from '@wwe-portal/ui/lib/lib';
import styles from './youtube-play-button.module.css';

const PlayCircle = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'absolute inset-8 rounded-full border-[3px] border-solid border-[#00E3FF] p-1 blur-[2px]',
        className
      )}
    />
  );
};

export const YoutubePlayButtonUI: FC<{
  imageElement: ReactNode;
  onClick: () => void;
}> = ({ imageElement, onClick }) => {
  return (
    <ClickableDiv className="relative" onClick={onClick}>
      <PlayCircle className={styles['youtube-btn-1']} />
      <PlayCircle className={styles['youtube-btn-2']} />
      <PlayCircle className={styles['youtube-btn-3']} />
      <ClickableDiv>{imageElement}</ClickableDiv>
    </ClickableDiv>
  );
};
